import React from 'react';
import { CreditCardIcon } from '@heroicons/react/24/outline';
import Visa from '../../../../assets/visa.svg';
import MasterCard from '../../../../assets/mastercard.svg';
import AmericanExpress from '../../../../assets/american-express.svg';
import Discover from '../../../../assets/discover.svg';
import CreditCardSvg from '../../../../assets/credit-card-icon.svg';

const brandImage = (brand) => {
  const b = String(brand || '').toLowerCase();
  if (b.includes('visa')) return Visa;
  if (b.includes('master')) return MasterCard;
  if (b.includes('amex') || b.includes('american')) return AmericanExpress;
  if (b.includes('discover')) return Discover;
  return CreditCardSvg;
};

const extractCard = (orderDetail) => {
  const payment = orderDetail?.payments?.[0] || {};
  const brand =
    orderDetail?.cardbrand ||
    orderDetail?.brand ||
    payment?.cardbrand ||
    payment?.brand ||
    payment?.card?.brand ||
    payment?.paymentmethoddetails?.card?.brand;
  const last4 =
    orderDetail?.cardlast4 ||
    orderDetail?.last4 ||
    payment?.cardlast4 ||
    payment?.last4 ||
    payment?.card?.last4 ||
    payment?.paymentmethoddetails?.card?.last4;
  return { brand, last4 };
};

const PaymentCard = ({ orderDetail }) => {
  const { brand, last4 } = extractCard(orderDetail);
  if (!brand && !last4) return null;

  return (
    <section
      className="reveal overflow-hidden rounded-md border border-slate-200 bg-white shadow-sm dark:border-slate-700 dark:bg-slate-800"
      aria-label="Payment method"
    >
      <div className="flex items-center gap-2 border-b border-slate-100 px-5 py-3 dark:border-slate-700/60">
        <div className="flex h-7 w-7 items-center justify-center rounded-md bg-slate-100 text-slate-500 dark:bg-slate-700 dark:text-slate-400">
          <CreditCardIcon className="h-4 w-4" />
        </div>
        <h3 className="text-[0.65rem] font-semibold uppercase tracking-[0.2em] text-slate-500 dark:text-slate-400">
          Payment
        </h3>
      </div>
      <div className="flex items-center gap-3 px-5 py-4">
        <img
          src={brandImage(brand)}
          alt={brand || 'Card'}
          className="h-7 w-auto"
        />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">
            {brand || 'Card'}
            {last4 && (
              <span className="ml-2 tabular-nums text-slate-500 dark:text-slate-400">
                ···· {last4}
              </span>
            )}
          </p>
          <p className="mt-0.5 text-xs text-slate-500 dark:text-slate-400">
            Paid
          </p>
        </div>
      </div>
    </section>
  );
};

export default PaymentCard;
